const FALLBACK_TIMEZONES = [
  'America/Denver',
  'America/Los_Angeles',
  'America/Chicago',
  'America/New_York',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Madrid',
  'Europe/Rome',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Asia/Shanghai',
  'Asia/Kolkata',
  'Australia/Sydney',
  'America/Mexico_City',
  'America/Sao_Paulo',
  'UTC',
];

export function detectTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Denver';
  } catch {
    return 'America/Denver';
  }
}

export function getTimeZoneOptions() {
  const zones =
    typeof Intl !== 'undefined' && Intl.supportedValuesOf
      ? Intl.supportedValuesOf('timeZone')
      : FALLBACK_TIMEZONES;

  return [...new Set([...zones, ...FALLBACK_TIMEZONES])].sort().map((timeZone) => ({
    value: timeZone,
    label: timeZone.replace(/_/g, ' '),
  }));
}
